import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const TransactionsContext = createContext();

export const TransactionsProvider = ({ children }) => {
  const [transactions, setTransactions] = useState([]);
  const { authToken, user } = useAuth();

  useEffect(() => {
    if (!authToken) {
      setTransactions([]);
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_HOST}/transaction-validations?email=${user?.email}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(async (response) => {
        const responseJson = await response.json();
        const transactions = responseJson.map((transaction) => {
          return {
            origin: transaction.origin.name,
            bank: transaction.origin.bank,
            value: new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(transaction.value),
            date: new Date(transaction.date).toLocaleDateString(),
            isValid: transaction.isValid,
          };
        });
        return transactions;
      })
      .then((data) => setTransactions(data));
  }, [authToken, user, user?.email]);

  return (
    <TransactionsContext.Provider value={{ transactions, setTransactions }}>
      {children}
    </TransactionsContext.Provider>
  );
};

export const useTransactions = () => {
  const context = useContext(TransactionsContext);
  if (!context) {
    throw new Error(
      "useTransactions must be used within a TransactionsProvider",
    );
  }
  return context;
};

